function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function(key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function _object_without_properties(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
import { bindTimestampHandler, getWebInitTimestamp } from "./time";
import { CUJStatus, PageReadyTiming, UserDropReason } from "./types";
const instances = {};
const createInstance = (instanceName = "") => {
  let _hasReportedPageReady = false;
  let _hasReportedPageCrash = false;
  let _hasReportedUserDrop = false;
  let _hasInit = false;
  let _hasReportedActualFMP = false;
  let _pageReadyTimestamp = -1;
  let _SlardarContainer;
  let _SlardarWindowGlobalName = "";
  let _SlardarHybridGlobalName = "";
  let _SparkMonitor;
  let _reportActualFMP;
  let _cuj = {};
  class TrackingModule {
    _sendEvent(payload) {
      try {
        var _window, _window1;
        if (_SlardarWindowGlobalName && typeof ((_window = window) === null || _window === void 0 ? void 0 : _window[_SlardarWindowGlobalName]) === "function") {
          window[_SlardarWindowGlobalName]("sendEvent", payload);
        }
        if (_SlardarHybridGlobalName && typeof ((_window1 = window) === null || _window1 === void 0 ? void 0 : _window1[_SlardarHybridGlobalName]) === "function") {
          const _ref = payload !== null && payload !== void 0 ? payload : {}, { name = "" } = _ref, rest = _object_without_properties(_ref, [
            "name"
          ]);
          window[_SlardarHybridGlobalName]("emit", "custom", _object_spread({
            eventName: `hybrid_tracking_${name !== null && name !== void 0 ? name : ""}`,
            level: 1
          }, rest));
        }
        if (_SlardarContainer) {
          _SlardarContainer.sendEvent(payload);
        }
      } catch (e) {
      }
    }
    resetForSPA() {
      _hasReportedActualFMP = false;
      _hasReportedPageReady = false;
      _hasReportedPageCrash = false;
      _hasReportedUserDrop = false;
      _pageReadyTimestamp = -1;
      _cuj = {};
    }
    reset() {
      this.resetForSPA();
      _hasInit = false;
      _SlardarContainer = null;
      _SlardarWindowGlobalName = "";
      _SlardarHybridGlobalName = "";
      _SparkMonitor = null;
      _reportActualFMP = null;
    }
    isInitialized() {
      return _hasInit;
    }
    constructor(instanceName2 = "") {
      this._pageReadyTiming = PageReadyTiming.ACTUAL_FMP;
      this.init = (arg) => {
        try {
          if (_hasInit) {
            return;
          }
          _hasInit = true;
          const { slardarContainer, slardarWindowGlobalName, slardarHybridGlobalName, sparkMonitor, pageReadyTiming = PageReadyTiming.CUSTOM, reportActualFMP } = arg !== null && arg !== void 0 ? arg : {};
          if (typeof slardarWindowGlobalName === "string") {
            _SlardarWindowGlobalName = slardarWindowGlobalName;
          }
          if (typeof slardarHybridGlobalName === "string") {
            _SlardarHybridGlobalName = slardarHybridGlobalName;
          }
          if (typeof reportActualFMP === "function") {
            _reportActualFMP = reportActualFMP;
          }
          if (typeof slardarContainer !== "undefined" && typeof slardarContainer.sendEvent === "function" && typeof slardarContainer.reportActualFMP === "function") {
            _SlardarContainer = slardarContainer;
          }
          if (typeof sparkMonitor !== "undefined") {
            _SparkMonitor = sparkMonitor;
          }
          this._pageReadyTiming = pageReadyTiming;
          bindTimestampHandler();
          this._registerUserDropEvent();
        } catch (e) {
        }
      };
      this._registerUserDropEvent = () => {
        window.addEventListener("beforeunload", this.reportUserDrop, true);
      };
      this.reportPageReady = () => {
        if (_hasReportedPageReady || _hasReportedUserDrop || _hasReportedPageCrash) {
          return;
        }
        if (this._pageReadyTiming === PageReadyTiming.ACTUAL_FMP) {
          this.reportActualFMP();
        }
        _hasReportedPageReady = true;
        let duration = 0;
        try {
          performance.mark("pageReady");
          duration = performance.measure("navigationStart_to_pageReady", "navigationStart", "pageReady").duration;
        } catch (e) {
          duration = Date.now() - getWebInitTimestamp();
        }
        _pageReadyTimestamp = duration;
        this._sendEvent({
          name: "page_ready",
          metrics: {
            time: duration
          }
        });
      };
      this.reportUserDrop = () => {
        if (_hasReportedPageReady || _hasReportedUserDrop) {
          return;
        }
        _hasReportedUserDrop = true;
        let duration = 0;
        try {
          performance.mark("userDrop");
          duration = performance.measure("navigationStart_to_userDrop", "navigationStart", "userDrop").duration;
        } catch (e) {
          duration = Date.now() - getWebInitTimestamp();
        }
        this._sendEvent({
          name: "user_drop",
          metrics: {
            time: duration
          },
          categories: {
            reason: _hasReportedPageCrash ? UserDropReason.CRASH : UserDropReason.ABORT
          }
        });
      };
      this.reportPageCrash = (error, hasDifferentTriggerTime = false, componentStack) => {
        var _message_substring, _stack_substring, _componentStack_substring;
        if (_hasReportedUserDrop || _hasReportedPageCrash) {
          return;
        }
        _hasReportedPageCrash = true;
        const { name = "", message, stack, _triggerTime = 0 } = error !== null && error !== void 0 ? error : {};
        let reportTime = 0;
        if (!reportTime) {
          try {
            performance.mark("pageCrashReporting");
            reportTime = performance.measure("navigationStart_to_pageCrashReporting", "navigationStart", "pageCrashReporting").duration;
          } catch (e) {
            reportTime = Date.now() - getWebInitTimestamp();
          }
        }
        const triggerTime = hasDifferentTriggerTime ? _triggerTime : reportTime;
        var _message_substring1, _stack_substring1, _componentStack_substring1;
        this._sendEvent({
          name: "page_crash",
          metrics: {
            time: triggerTime !== null && triggerTime !== void 0 ? triggerTime : 0
          },
          categories: {
            isTriggeredBeforePageReady: triggerTime < _pageReadyTimestamp || !_hasReportedPageReady,
            isReportedBeforePageReady: reportTime < _pageReadyTimestamp || !_hasReportedPageReady,
            name,
            // slardar max string length 256 chars
            message: (_message_substring1 = message === null || message === void 0 ? void 0 : (_message_substring = message.substring) === null || _message_substring === void 0 ? void 0 : _message_substring.call(message, 0, 256)) !== null && _message_substring1 !== void 0 ? _message_substring1 : "",
            stack: (_stack_substring1 = stack === null || stack === void 0 ? void 0 : (_stack_substring = stack.substring) === null || _stack_substring === void 0 ? void 0 : _stack_substring.call(stack, 0, 256)) !== null && _stack_substring1 !== void 0 ? _stack_substring1 : "",
            componentStack: (_componentStack_substring1 = componentStack === null || componentStack === void 0 ? void 0 : (_componentStack_substring = componentStack.substring) === null || _componentStack_substring === void 0 ? void 0 : _componentStack_substring.call(componentStack, 0, 256)) !== null && _componentStack_substring1 !== void 0 ? _componentStack_substring1 : ""
          }
        });
      };
      this.reportActualFMP = () => {
        try {
          if (_hasReportedActualFMP) {
            return;
          }
          _hasReportedActualFMP = true;
          if (typeof (_SparkMonitor === null || _SparkMonitor === void 0 ? void 0 : _SparkMonitor.mark) === "function") {
            _SparkMonitor.mark("fmp");
          }
          if (_reportActualFMP) {
            _reportActualFMP();
          }
          if (typeof (_SlardarContainer === null || _SlardarContainer === void 0 ? void 0 : _SlardarContainer.reportActualFMP) === "function") {
            _SlardarContainer.reportActualFMP();
          }
        } catch (e) {
        }
      };
      this.reportCUJ = (name, status, extra) => {
        var _errorInfo_substring, _detailStr_substring;
        const cujStartMetricsName = `cuj_${name}_${CUJStatus.START}`;
        const currentMetricsName = `cuj_${name}_${status}`.replace(/\s/g, "_");
        let durationFromNavStart = 0;
        let durationFromCUJStart = 0;
        try {
          performance.mark(currentMetricsName);
          durationFromNavStart = performance.measure(`navigationStart_to_${currentMetricsName}`, "navigationStart", currentMetricsName).duration;
          durationFromCUJStart = performance.measure(`${cujStartMetricsName}_to_${currentMetricsName}`, cujStartMetricsName, currentMetricsName).duration;
        } catch (e) {
          durationFromNavStart = Date.now() - getWebInitTimestamp();
          if (status === CUJStatus.START) {
            _cuj[name] = {
              [CUJStatus.START]: Date.now()
            };
            durationFromCUJStart = 0;
          } else {
            if (!_cuj[name]) {
              return;
            }
            _cuj[name][status] = Date.now();
            var _cuj_name_CUJStatus_START;
            durationFromCUJStart = _cuj[name][status] - ((_cuj_name_CUJStatus_START = _cuj[name][CUJStatus.START]) !== null && _cuj_name_CUJStatus_START !== void 0 ? _cuj_name_CUJStatus_START : 0);
          }
        }
        const { error, detail, stepName } = extra !== null && extra !== void 0 ? extra : {};
        var _error_toString;
        const errorInfo = typeof error === "string" ? error : (_error_toString = error === null || error === void 0 ? void 0 : error.toString()) !== null && _error_toString !== void 0 ? _error_toString : "";
        var _error_stack;
        const detailStr = detail ? detail : (_error_stack = error === null || error === void 0 ? void 0 : error.stack) !== null && _error_stack !== void 0 ? _error_stack : "";
        var _errorInfo_substring1, _detailStr_substring1;
        this._sendEvent({
          name: "pns_cuj",
          metrics: {
            timestamp: durationFromNavStart,
            duration: durationFromCUJStart
          },
          categories: {
            status,
            name,
            stepName,
            // slardar max string length 256 chars
            error: (_errorInfo_substring1 = errorInfo === null || errorInfo === void 0 ? void 0 : (_errorInfo_substring = errorInfo.substring) === null || _errorInfo_substring === void 0 ? void 0 : _errorInfo_substring.call(errorInfo, 0, 256)) !== null && _errorInfo_substring1 !== void 0 ? _errorInfo_substring1 : "",
            detail: (_detailStr_substring1 = detailStr === null || detailStr === void 0 ? void 0 : (_detailStr_substring = detailStr.substring) === null || _detailStr_substring === void 0 ? void 0 : _detailStr_substring.call(detailStr, 0, 256)) !== null && _detailStr_substring1 !== void 0 ? _detailStr_substring1 : ""
          }
        });
      };
      if (!instanceName2) {
        if (!TrackingModule._instance) {
          TrackingModule._instance = this;
        }
        return TrackingModule._instance;
      } else {
        instances[instanceName2] = this;
        return this;
      }
    }
  }
  if (!instanceName) {
    return new TrackingModule();
  }
  if (!instances[instanceName]) {
    instances[instanceName] = new TrackingModule(instanceName);
  }
  return instances[instanceName];
};
const TrackingModuleSingleton = createInstance();
export {
  TrackingModuleSingleton as TrackingModule,
  createInstance
};
